(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hanogram-collection-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const roots = document.querySelectorAll('[data-hc-root]');

    roots.forEach((root) => {
      if (root.dataset.hcReady === 'true') return;
      root.dataset.hcReady = 'true';

      const closeDialog = (dialog) => {
        if (!dialog || !dialog.open) return;
        dialog.close();
      };

      root.querySelectorAll('[data-hc-open]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = root.querySelector(`[data-hc-dialog="${button.dataset.hcOpen}"]`);
          if (!dialog) return;
          dialog.showModal();
          document.documentElement.classList.add('hc-lock');
          const focusTarget = dialog.querySelector('input, button, a');
          if (focusTarget) window.setTimeout(() => focusTarget.focus(), 40);
        });
      });

      root.querySelectorAll('[data-hc-dialog]').forEach((dialog) => {
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('hc-lock');
        });

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog(dialog);
        });

        dialog.querySelectorAll('[data-hc-close]').forEach((button) => {
          button.addEventListener('click', () => closeDialog(dialog));
        });
      });

      const summary = root.querySelector('[data-hc-summary]');
      const summaryToggle = root.querySelector('[data-hc-summary-toggle]');
      if (summary && summaryToggle) {
        const summaryText = summary.querySelector('p');
        const updateSummaryToggle = () => {
          if (!summaryText) return;
          const wasExpanded = summary.classList.contains('is-expanded');
          summary.classList.remove('is-expanded');
          const needsToggle = summaryText.scrollHeight > summaryText.clientHeight + 1;
          summary.classList.toggle('is-expanded', wasExpanded && needsToggle);
          summaryToggle.hidden = !needsToggle;

          if (!needsToggle) {
            summaryToggle.setAttribute('aria-expanded', 'false');
            summaryToggle.querySelector('[data-hc-more]').hidden = false;
            summaryToggle.querySelector('[data-hc-less]').hidden = true;
          }
        };

        window.requestAnimationFrame(updateSummaryToggle);
        window.addEventListener('resize', updateSummaryToggle, { passive: true });

        summaryToggle.addEventListener('click', () => {
          const expanded = summaryToggle.getAttribute('aria-expanded') === 'true';
          summaryToggle.setAttribute('aria-expanded', String(!expanded));
          summary.classList.toggle('is-expanded', !expanded);
          summaryToggle.querySelector('[data-hc-more]').hidden = !expanded;
          summaryToggle.querySelector('[data-hc-less]').hidden = expanded;
        });
      }

      const search = root.querySelector('[data-hc-model-search]');
      if (search) {
        search.addEventListener('input', () => {
          const term = search.value.trim().toLowerCase();
          let visible = 0;
          root.querySelectorAll('[data-hc-model]').forEach((model) => {
            const matches = model.dataset.hcModel.includes(term);
            model.hidden = !matches;
            if (matches) visible += 1;
          });
          const empty = root.querySelector('[data-hc-model-empty]');
          if (empty) empty.hidden = visible !== 0;
        });
      }

      const currentModelDisplay = root.querySelector('[data-hc-current-model]');
      const currentTypeDisplay = root.querySelector('[data-hc-current-type]');
      const collectionTitleDisplay = root.querySelector('[data-hc-collection-title]');
      const collectionSummaryDisplay = root.querySelector('[data-hc-summary] p');
      const collectionBreadcrumbDisplay = document.querySelector('.tt-breadcrumb li:last-child');
      const allModelLink = root.querySelector('[data-hc-model-all]');
      const modelLinks = [...root.querySelectorAll('[data-hc-model-label]')];
      const modelLabels = modelLinks.map((model) => model.dataset.hcModelLabel);
      const pageUrl = new URL(window.location.href);
      const modelFromUrl = pageUrl.searchParams.get('model');
      const typeFromUrl = pageUrl.searchParams.get('case_type');
      const modelFromPage = currentModelDisplay ? currentModelDisplay.textContent.trim() : '';
      const normalizeModelToken = (value) => decodeURIComponent(value || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
      const pageModelToken = normalizeModelToken(`${pageUrl.pathname} ${document.title}`);
      const inferredModel = modelLabels.find((label) => (
        pageModelToken.includes(normalizeModelToken(label))
      ));
      const currentModel = modelLabels.includes(modelFromUrl)
        ? modelFromUrl
        : modelLabels.includes(modelFromPage)
          ? modelFromPage
          : inferredModel || '';
      if (currentModel === 'iPhone 17 Pro') {
        const showSelectedModel = (value) => value.replace(/iphone 17 pro max/gi, 'iPhone 17 Pro');
        if (collectionTitleDisplay) {
          const originalTitle = collectionTitleDisplay.dataset.originalTitle || collectionTitleDisplay.textContent.trim();
          collectionTitleDisplay.textContent = showSelectedModel(originalTitle);
        }
        if (collectionSummaryDisplay) {
          collectionSummaryDisplay.textContent = showSelectedModel(collectionSummaryDisplay.textContent);
        }
        if (collectionBreadcrumbDisplay) {
          collectionBreadcrumbDisplay.textContent = showSelectedModel(collectionBreadcrumbDisplay.textContent);
        }
        document.title = showSelectedModel(document.title);
      }

      if (currentModel) {
        if (currentModelDisplay) currentModelDisplay.textContent = currentModel;
        if (allModelLink) {
          allModelLink.classList.remove('is-selected');
          const allSelectedLabel = allModelLink.querySelector('[data-hc-model-all-selected]');
          if (allSelectedLabel) allSelectedLabel.hidden = true;
        }
        modelLinks.forEach((model) => {
          const selected = model.dataset.hcModelLabel === currentModel;
          model.classList.toggle('is-selected', selected);
          const selectedLabel = model.querySelector('[data-hc-model-selected]');
          if (selectedLabel) selectedLabel.hidden = !selected;
        });
      } else {
        if (currentModelDisplay) currentModelDisplay.textContent = root.dataset.hcModelPlaceholder;
        if (currentTypeDisplay) currentTypeDisplay.textContent = root.dataset.hcCasePlaceholder;
        if (allModelLink) {
          allModelLink.classList.add('is-selected');
          const allSelectedLabel = allModelLink.querySelector('[data-hc-model-all-selected]');
          if (allSelectedLabel) allSelectedLabel.hidden = false;
        }
      }

      if (allModelLink) {
        const destination = new URL(allModelLink.href, window.location.origin);
        const currentParams = new URL(window.location.href).searchParams;
        currentParams.forEach((value, key) => {
          if (key !== 'page' && key !== 'model') destination.searchParams.set(key, value);
        });
        allModelLink.href = destination.toString();
      }

      modelLinks.forEach((modelLink) => {
        const destination = new URL(modelLink.href, window.location.origin);
        const currentParams = new URL(window.location.href).searchParams;
        currentParams.forEach((value, key) => {
          if (key !== 'page' && key !== 'model') destination.searchParams.set(key, value);
        });
        destination.searchParams.set('model', modelLink.dataset.hcModelLabel);
        modelLink.href = destination.toString();
      });

      const caseSelect = root.querySelector('[data-hc-case-select]');
      const caseDetails = root.querySelector('[data-hc-case-details]');
      const caseCards = [...root.querySelectorAll('[data-hc-case-card]')];
      caseCards.forEach((card) => {
        const modelImages = [...card.querySelectorAll('[data-hc-case-image-models]')];
        const matchingImage = modelImages.find((image) => (
          image.dataset.hcCaseImageModels || ''
        ).split('^').includes(currentModel));
        if (matchingImage) {
          modelImages.forEach((image) => {
            image.hidden = image !== matchingImage;
          });
        }
        const prices = [...card.querySelectorAll('[data-hc-case-price]')];
        const matchingPrice = prices.find((price) => price.dataset.hcPriceModel === currentModel);
        prices.forEach((price) => {
          price.hidden = matchingPrice
            ? price !== matchingPrice
            : Boolean(price.dataset.hcPriceModel);
        });
      });
      const caseUrl = (card) => {
        const url = new URL(card.dataset.url, window.location.origin);
        const modelHandles = card.dataset.modelHandles
          ? card.dataset.modelHandles.split('~')
          : [];
        const modelHandle = modelHandles
          .map((entry) => entry.split('=>'))
          .find(([model]) => model === currentModel);
        if (modelHandle?.[1]) {
          url.pathname = `${window.Shopify?.routes?.root || '/'}collections/${modelHandle[1]}`.replace(/\/+/g, '/');
        }
        const currentParams = new URL(window.location.href).searchParams;
        currentParams.forEach((value, key) => {
          if (key !== 'page' && key !== 'model') url.searchParams.set(key, value);
        });
        if (currentModel) {
          url.searchParams.set('model', currentModel);
        }
        url.searchParams.set('case_type', card.dataset.typeKey);
        return url.toString();
      };
      const selectCaseCard = (card) => {
        caseCards.forEach((item) => {
          item.classList.remove('is-selected');
          item.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('is-selected');
        card.setAttribute('aria-pressed', 'true');
        if (caseSelect) caseSelect.href = caseUrl(card);
        if (currentTypeDisplay) currentTypeDisplay.textContent = card.dataset.label;
        const magsafeModels = ['iPhone 17 Pro Max', 'iPhone 17 Pro', 'iPhone Air', 'iPhone 17'];
        const copyTemplateId = magsafeModels.includes(currentModel)
          ? card.dataset.magsafeCopyTemplate
          : card.dataset.copyTemplate;
        const copyTemplate = document.getElementById(copyTemplateId);
        if (caseDetails && copyTemplate) {
          caseDetails.replaceChildren(copyTemplate.content.cloneNode(true));
        }
      };

      if (currentModel) {
        caseCards.forEach((card) => {
          const compatibleModels = card.dataset.compatibleModels
            ? card.dataset.compatibleModels.split('^')
            : [];
          card.hidden = Boolean(currentModel && compatibleModels.length && !compatibleModels.includes(currentModel));
        });
        const selectedCase = caseCards.find((card) => (
          typeFromUrl
            ? card.dataset.typeKey === typeFromUrl
            : card.classList.contains('is-selected')
        ) && !card.hidden);
        const fallbackCase = caseCards.find((card) => !card.hidden);
        if (selectedCase || fallbackCase) selectCaseCard(selectedCase || fallbackCase);
      } else {
        caseCards.forEach((card) => {
          card.classList.remove('is-selected');
          card.setAttribute('aria-pressed', 'false');
        });
      }

      caseCards.forEach((card) => {
        card.addEventListener('click', () => {
          selectCaseCard(card);
        });
      });

      root.querySelectorAll('[data-hc-filter-more]').forEach((button) => {
        button.addEventListener('click', () => {
          const values = button.parentElement.querySelector('[data-hc-filter-values]');
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          values.classList.toggle('is-expanded', !expanded);
          button.textContent = expanded ? button.dataset.moreLabel : button.dataset.lessLabel;
        });
      });

      const filterForm = root.querySelector('[data-hc-filter-form]');
      if (filterForm) {
        const filterClear = filterForm.querySelector('[data-hc-filter-clear]');
        if (filterClear && currentModel) {
          const clearUrl = new URL(filterClear.href);
          clearUrl.searchParams.set('model', currentModel);
          if (typeFromUrl) clearUrl.searchParams.set('case_type', typeFromUrl);
          filterClear.href = clearUrl.toString();
        }
        filterForm.addEventListener('submit', (event) => {
          event.preventDefault();
          const params = new URLSearchParams(new FormData(filterForm));
          [...params.entries()].forEach(([key, value]) => {
            if (!value) params.delete(key);
          });
          if (currentModel) {
            params.set('model', currentModel);
          }
          if (typeFromUrl) {
            params.set('case_type', typeFromUrl);
          }
          const selectedTags = [...filterForm.querySelectorAll('[data-hc-tag]:checked')]
            .map((input) => encodeURIComponent(input.value));
          params.delete('page');
          const query = params.toString();
          const path = selectedTags.length
            ? `${root.dataset.collectionUrl}/${selectedTags.join('+')}`
            : root.dataset.collectionUrl;
          window.location.assign(`${path}${query ? `?${query}` : ''}`);
        });
      }

      root.querySelectorAll('[data-hc-sort]').forEach((radio) => {
        radio.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', radio.value);
          url.searchParams.delete('page');
          window.location.assign(url.toString());
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hanogram-discount-widget"] && !Shopify.designMode) return;
  try {
    (() => {
    const widgetSelector = '[data-hanogram-discount-widget]';
    let refreshTimer;
    let refreshInProgress = false;

    const normalizeCode = (code) => String(code || '').trim().toUpperCase();

    const getCodes = (widget) => {
      return String(widget.dataset.appliedCodes || '')
        .split(',')
        .map(normalizeCode)
        .filter(Boolean);
    };

    const getNativeCodes = (widget) => {
      return String(widget.dataset.nativeCodes || '')
        .split(',')
        .map(normalizeCode)
        .filter(Boolean);
    };

    const getRootUrl = (widget) => {
      const root = widget.dataset.rootUrl || '/';
      return root.endsWith('/') ? root : `${root}/`;
    };

    const setLoading = (widget, loading) => {
      const button = widget.querySelector('[data-discount-apply]');
      const input = widget.querySelector('[data-discount-input]');
      widget.classList.toggle('is-loading', loading);
      if (button) button.disabled = loading;
      if (input) input.disabled = loading;
    };

    const setMessage = (widget, message) => {
      const target = widget.querySelector('[data-discount-message]');
      if (!target) return;
      target.textContent = message || '';
      target.hidden = !message;
    };

    const updateDiscounts = (widget, codes) => {
      return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();
        const failRequest = () => reject(new Error(widget.dataset.errorMessage));
        const timeout = window.setTimeout(failRequest, 8000);
        request.open('POST', `${getRootUrl(widget)}cart/update.js`, true);
        request.setRequestHeader('Accept', 'application/json');
        request.setRequestHeader('Content-Type', 'application/json');
        request.timeout = 8000;
        request.onload = () => {
          window.clearTimeout(timeout);
          let data = {};
          try {
            data = JSON.parse(request.responseText || '{}');
          } catch (error) {
            data = {};
          }
          if (request.status >= 200 && request.status < 300) {
            resolve(data);
            return;
          }
          reject(new Error(data.description || data.message || widget.dataset.errorMessage));
        };
        request.onerror = () => {
          window.clearTimeout(timeout);
          failRequest();
        };
        request.onabort = () => {
          window.clearTimeout(timeout);
          failRequest();
        };
        request.ontimeout = () => {
          window.clearTimeout(timeout);
          failRequest();
        };
        request.send(JSON.stringify({ discount: codes.join(',') }));
      });
    };

    const fetchSurfaceDocument = async (widget) => {
      const root = getRootUrl(widget);
      const query = window.location.search || '';
      const url = widget.dataset.placement === 'cart'
        ? `${root}cart${query}`
        : `${window.location.pathname}${query}`;
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(url, {
          cache: 'no-store',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: controller.signal
        });
        if (!response.ok) throw new Error(widget.dataset.errorMessage);
        const html = await response.text();
        return new DOMParser().parseFromString(html, 'text/html');
      } finally {
        window.clearTimeout(timeout);
      }
    };

    const cleanupLegacyWidget = (root = document) => {
      root.querySelectorAll('.docapp-widget').forEach((element) => element.remove());
      root.querySelectorAll('.docapp-replaces').forEach((element) => {
        element.classList.remove('docapp-replaces');
        element.style.removeProperty('display');
      });
    };

    const replaceSurface = (widget, nextDocument) => {
      if (widget.dataset.placement === 'drawer') {
        const current = document.querySelector('header .tt-cart .tt-cart-box');
        const replacement = nextDocument.querySelector('header .tt-cart .tt-cart-box');
        if (!current || !replacement) throw new Error(widget.dataset.errorMessage);
        current.replaceWith(replacement);
        cleanupLegacyWidget();
        initWidgets();
        return;
      }
      window.location.reload();
    };

    const applyCode = async (widget, code) => {
      const normalized = normalizeCode(code);
      const existingCodes = getCodes(widget);
      if (!normalized) return;
      if (existingCodes.includes(normalized)) {
        setMessage(widget, '');
        return;
      }
      setLoading(widget, true);
      setMessage(widget, '');
      try {
        const cartData = await updateDiscounts(widget, [...existingCodes, normalized]);
        const discountResult = Array.isArray(cartData.discount_codes)
          ? cartData.discount_codes.find((item) => normalizeCode(item.code) === normalized)
          : null;
        if (discountResult && discountResult.applicable === false) {
          setMessage(widget, widget.dataset.invalidMessage);
          return;
        }
        window.location.reload();
      } catch (error) {
        setMessage(widget, error.message || widget.dataset.errorMessage);
      } finally {
        setLoading(widget, false);
      }
    };

    const removeCode = async (widget, code) => {
      const remainingCodes = getCodes(widget).filter((item) => item !== normalizeCode(code));
      setLoading(widget, true);
      setMessage(widget, '');
      try {
        await updateDiscounts(widget, remainingCodes);
        window.location.reload();
      } catch (error) {
        setMessage(widget, error.message || widget.dataset.errorMessage);
      } finally {
        setLoading(widget, false);
      }
    };

    const syncAutoCode = async (widget) => {
      if (widget.dataset.autoEnabled !== 'true') return;
      if (widget.dataset.autoAttempted === 'true') return;
      const code = normalizeCode(widget.dataset.autoCode);
      const itemCount = Number(widget.dataset.itemCount || 0);
      const eligible = widget.dataset.autoEligible === 'true';
      const nativeCodes = getNativeCodes(widget).filter((item) => item !== code);
      const desiredCodes = eligible ? [...nativeCodes, code] : nativeCodes;
      if (!code) return;

      const syncKey = `${itemCount}:${eligible}:${desiredCodes.join(',')}`;
      if (document.documentElement.dataset.hanogramAutoDiscountState === syncKey) return;
      document.documentElement.dataset.hanogramAutoDiscountState = syncKey;
      widget.dataset.autoAttempted = 'true';
      setLoading(widget, true);
      try {
        await updateDiscounts(widget, desiredCodes);
      } catch (error) {
        if (document.documentElement.dataset.hanogramAutoDiscountState === syncKey) {
          delete document.documentElement.dataset.hanogramAutoDiscountState;
        }
      } finally {
        const input = widget.querySelector('[data-discount-input]');
        if (input && normalizeCode(input.value) === code) input.value = '';
        setLoading(widget, false);
      }
    };

    const refreshCartWidget = async () => {
      const widget = document.querySelector('.hanogram-discount-widget--cart');
      if (!widget || refreshInProgress) return;
      refreshInProgress = true;
      try {
        const nextDocument = await fetchSurfaceDocument(widget);
        const replacement = nextDocument.querySelector('.hanogram-discount-widget--cart');
        if (replacement) widget.replaceWith(replacement);
        cleanupLegacyWidget();
        initWidgets();
      } catch (error) {
        setMessage(widget, error.message || widget.dataset.errorMessage);
      } finally {
        refreshInProgress = false;
      }
    };

    const refreshDrawer = async () => {
      const widget = document.querySelector('.hanogram-discount-widget--drawer');
      if (!widget || refreshInProgress) return;
      refreshInProgress = true;
      try {
        const nextDocument = await fetchSurfaceDocument(widget);
        const current = document.querySelector('header .tt-cart .tt-cart-box');
        const replacement = nextDocument.querySelector('header .tt-cart .tt-cart-box');
        if (current && replacement) current.replaceWith(replacement);
        cleanupLegacyWidget();
        initWidgets();
      } catch (error) {
        setMessage(widget, error.message || widget.dataset.errorMessage);
      } finally {
        refreshInProgress = false;
      }
    };

    const scheduleSurfaceRefresh = () => {
      window.clearTimeout(refreshTimer);
      refreshTimer = window.setTimeout(() => {
        if (document.querySelector('.hanogram-discount-widget--cart')) return;
        refreshDrawer();
      }, 500);
    };

    const initWidgets = () => {
      cleanupLegacyWidget();
      document.querySelectorAll(widgetSelector).forEach((widget) => {
        syncAutoCode(widget);
      });
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-discount-form]');
      if (!form) return;
      event.preventDefault();
      const widget = form.closest(widgetSelector);
      const input = form.querySelector('[data-discount-input]');
      if (widget && input) applyCode(widget, input.value);
    });

    document.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-remove-discount-code]');
      if (!removeButton) return;
      const widget = removeButton.closest(widgetSelector);
      if (widget) removeCode(widget, removeButton.dataset.removeDiscountCode);
    });

    if (window.jQuery) {
      window.jQuery(document).ajaxComplete((event, request, settings) => {
        const url = String(settings && settings.url || '');
        if (/\/cart\/(add|change|clear|update)(\.js)?/.test(url)) scheduleSurfaceRefresh();
      });
    }

    const observer = new MutationObserver(() => cleanupLegacyWidget());
    observer.observe(document.documentElement, { childList: true, subtree: true });

    window.HanogramDiscount = {
      init: initWidgets,
      refreshCart: refreshCartWidget,
      refreshDrawer
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initWidgets, { once: true });
    } else {
      initWidgets();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hanogram-hk-pickup"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.querySelector('[data-hanogram-pickup]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const config = JSON.parse(root.querySelector('[data-hkp-config]').textContent);
    const locations = [...root.querySelectorAll('[data-hanogram-pickup-data]')]
      .flatMap((element) => JSON.parse(element.textContent));
    const dialog = root.querySelector('[data-hkp-dialog]');
    const form = root.closest('form');
    const pickupPanel = root.querySelector('[data-hkp-pickup-panel]');
    const zoneSelect = root.querySelector('[data-hkp-zone]');
    const districtSelect = root.querySelector('[data-hkp-district]');
    const typeSelect = root.querySelector('[data-hkp-type]');
    const results = root.querySelector('[data-hkp-results]');
    const resultStatus = root.querySelector('[data-hkp-result-status]');
    const error = root.querySelector('[data-hkp-error]');
    const confirmButton = root.querySelector('[data-hkp-confirm]');
    const methods = [...root.querySelectorAll('[data-hkp-method]')];
    const typeLabels = {
      store: config.strings.typeStore,
      locker: config.strings.typeLocker,
      ok: config.strings.typeOk,
      partner: config.strings.typePartner
    };
    const resultLimit = 80;
    let selectedCode = config.currentCode;
    let isSaving = false;
    const confirmText = confirmButton.textContent;
    const islandDistricts = ['中環', '上環', '西環', '西營盤', '堅尼地城', '薄扶林', '山頂', '灣仔', '銅鑼灣', '跑馬地', '北角', '炮台山', '鰂魚涌', '太古', '西灣河', '筲箕灣', '柴灣', '小西灣', '香港仔', '黃竹坑', '鴨脷洲', '赤柱', '淺水灣'];
    const kowloonDistricts = ['九龍城', '九龍塘', '九龍灣', '啟德', '土瓜灣', '佐敦', '何文田', '大角咀', '太子', '尖沙咀', '慈雲山', '新蒲崗', '旺角', '油塘', '油麻地', '深水埗', '石硤尾', '秀茂坪', '觀塘', '鑽石山', '長沙灣', '黃大仙', '荔枝角', '紅磡', '藍田'];

    const replaceToken = (text, token, value) => text.replace(`[${token}]`, value);
    const currentMethod = () => methods.find((input) => input.checked)?.value || '';
    const selectedLocation = () => locations.find((location) => location[3] === selectedCode);
    const zoneForLocation = (location) => {
      if (location[0] === 'mo') return 'macau';
      const address = `${location[2]} ${location[5]}`;
      if (address.includes('九龍') || kowloonDistricts.some((district) => address.includes(district))) return 'kowloon';
      if (address.includes('新界')) return 'nt';
      if (address.includes('香港島') || islandDistricts.some((district) => address.includes(district))) return 'island';
      return 'nt';
    };
    const provinceForZone = (zone) => ({
      island: 'Hong Kong Island',
      kowloon: 'Kowloon',
      nt: 'New Territories'
    })[zone] || '';
    const animate = (callback) => {
      if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(callback);
      } else {
        callback();
      }
    };
    const setError = (message = '') => {
      error.textContent = message;
      error.hidden = !message;
    };
    const matchesZoneFilter = (location) => {
      return zoneSelect.value === 'all' || zoneForLocation(location) === zoneSelect.value;
    };
    const matchesBaseFilter = (location) => {
      return matchesZoneFilter(location) && (typeSelect.value === 'all' || location[1] === typeSelect.value);
    };
    const updateDistricts = () => {
      const districts = [...new Set(locations.filter(matchesZoneFilter).map((location) => location[2]).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b, config.locale));
      districtSelect.replaceChildren();
      const allOption = document.createElement('option');
      allOption.value = '';
      allOption.textContent = config.strings.allDistricts;
      districtSelect.append(allOption);
      districts.forEach((district) => {
        const option = document.createElement('option');
        option.value = district;
        option.textContent = district;
        districtSelect.append(option);
      });
    };
    const renderResults = () => {
      const matches = locations.filter((location) => {
        if (!matchesBaseFilter(location)) return false;
        return !districtSelect.value || location[2] === districtSelect.value;
      });
      results.replaceChildren();
      if (!matches.length) {
        const empty = document.createElement('p');
        empty.className = 'hkp__empty';
        empty.textContent = config.strings.noResults;
        results.append(empty);
        resultStatus.textContent = config.strings.noResults;
        return;
      }
      matches.slice(0, resultLimit).forEach((location) => {
        const label = document.createElement('label');
        label.className = 'hkp__location';
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'hkp-location';
        input.value = location[3];
        input.checked = location[3] === selectedCode;
        const copy = document.createElement('span');
        const title = document.createElement('strong');
        title.textContent = `${typeLabels[location[1]]} ${location[3]}`;
        const address = document.createElement('small');
        address.textContent = `${location[4]} · ${location[5]}`;
        copy.append(title, address);
        if (location[6]) {
          const hours = document.createElement('small');
          hours.textContent = `${config.strings.hours}：${location[6]}`;
          copy.append(hours);
        }
        label.append(input, copy);
        results.append(label);
      });
      let status = replaceToken(config.strings.resultSummary, 'count', matches.length);
      if (matches.length > resultLimit) status += ` ${replaceToken(config.strings.resultLimit, 'limit', resultLimit)}`;
      resultStatus.textContent = status;
    };
    const updatePanels = () => {
      const pickup = currentMethod() === 'pickup';
      animate(() => {
        pickupPanel.hidden = !pickup;
      });
      confirmButton.disabled = !pickup || !selectedLocation() || isSaving;
      setError();
      if (pickup) renderResults();
    };
    const openDialog = () => {
      methods.forEach((input) => {
        input.checked = false;
      });
      zoneSelect.value = 'all';
      typeSelect.value = 'all';
      updateDistricts();
      updatePanels();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    };
    const closeDialog = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    };
    const submitCartForm = (attributes, shippingAddress) => {
      if (!form || typeof HTMLFormElement === 'undefined') return false;
      form.querySelectorAll('[data-hkp-cart-field]').forEach((input) => input.remove());
      Object.entries(attributes).forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `attributes[${name}]`;
        input.value = value;
        input.dataset.hkpCartField = '';
        form.append(input);
      });
      const checkoutAction = new URL(form.getAttribute('action') || form.action, window.location.origin);
      checkoutAction.search = '';
      Object.entries(shippingAddress).forEach(([name, value]) => {
        checkoutAction.searchParams.set(`checkout[shipping_address][${name}]`, value);
      });
      form.action = checkoutAction.toString();
      const checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'checkout';
      checkoutInput.dataset.hkpCartField = '';
      form.append(checkoutInput);
      try {
        HTMLFormElement.prototype.submit.call(form);
      } catch (submitError) {
        return false;
      }
      return true;
    };
    const saveAndCheckout = async () => {
      if (isSaving) return;
      const pickup = currentMethod() === 'pickup';
      const location = selectedLocation();
      if (pickup && !location) {
        setError(config.strings.selectRequired);
        results.focus({ preventScroll: false });
        return;
      }
      isSaving = true;
      setError();
      confirmButton.disabled = true;
      const originalText = confirmButton.textContent;
      confirmButton.textContent = config.strings.saving;
      const attributes = {
        '送貨方式': '',
        '順豐自取地區': '',
        '順豐網點類型': '',
        '順豐網點代碼': '',
        '順豐網點名稱': '',
        '順豐自取地址': ''
      };
      const zone = pickup ? zoneForLocation(location) : '';
      const shippingAddress = pickup ? {
        address1: `${typeLabels[location[1]]} ${location[3]}`,
        address2: location[5].slice(0, 255),
        city: location[2],
        province: provinceForZone(zone),
        country: location[0] === 'mo' ? 'Macao' : 'Hong Kong'
      } : {
        address1: '',
        address2: '',
        city: '',
        province: ''
      };
      if (submitCartForm(attributes, shippingAddress)) return;
      try {
        const response = await fetch(config.cartUpdateUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ attributes })
        });
        if (!response.ok) throw new Error(String(response.status));
        const checkoutUrl = new URL(config.checkoutUrl, window.location.origin);
        Object.entries(shippingAddress).forEach(([name, value]) => {
          checkoutUrl.searchParams.set(`checkout[shipping_address][${name}]`, value);
        });
        window.location.assign(checkoutUrl.toString());
      } catch (requestError) {
        isSaving = false;
        confirmButton.disabled = false;
        confirmButton.textContent = originalText;
        setError(config.strings.saveError);
      }
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-hkp-method]')) updatePanels();
      if (event.target === zoneSelect) {
        updateDistricts();
        renderResults();
      }
      if (event.target === districtSelect || event.target === typeSelect) renderResults();
      if (event.target.name === 'hkp-location') {
        selectedCode = event.target.value;
        confirmButton.disabled = false;
        setError();
      }
    });
    methods.find((input) => input.value === 'delivery')?.addEventListener('click', () => queueMicrotask(saveAndCheckout));
    root.querySelectorAll('[data-hkp-open]').forEach((button) => button.addEventListener('click', openDialog));
    root.querySelectorAll('[data-hkp-close]').forEach((button) => button.addEventListener('click', closeDialog));
    confirmButton.addEventListener('click', saveAndCheckout);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    if (form) {
      form.addEventListener('submit', (event) => {
        if (event.submitter?.matches('[name="checkout"], [data-hkp-checkout]')) {
          event.preventDefault();
          openDialog();
        }
      }, true);
    }
    const ensureDialogClosed = () => {
      if (dialog.hasAttribute('open')) closeDialog();
      isSaving = false;
      confirmButton.textContent = confirmText;
      confirmButton.disabled = true;
    };
    ensureDialogClosed();
    window.addEventListener('pageshow', ensureDialogClosed);
  })();
  } catch(e) { console.error(e); }
})();

})();
